import type { App } from 'vue'
import { useAuthStore } from '../stores/auth'
import { initializeApiInterceptors } from '../plugins/interceptors'

export default {
  install(app: App) {
    // Initialiser les intercepteurs API
    initializeApiInterceptors()

    // Initialiser l'authentification au démarrage de l'application
    const authStore = useAuthStore()

    // Démarrer l'authentification en arrière-plan
    authStore.initialize().catch(error => {
      console.error('Erreur lors de l\'initialisation de l\'authentification:', error)
    })

    // Ajouter une propriété globale pour accéder facilement au store d'auth
    app.config.globalProperties.$auth = authStore
  }
}
